export var getLayerInPageElements = function (theme) {
    return theme.v1.layers.inPageElements.base;
};
export var getLayerFixedElements = function (theme) {
    return theme.v1.layers.fixedElements.base;
};
export var getLayerOverlappingElement = function (theme) {
    return theme.v1.layers.overlappingElement.base;
};
export var getLayerAccessibility = function (theme) {
    return theme.v1.layers.accessibility.base;
};
export var getLayerImportantMessages = function (theme) {
    return theme.v1.layers.importantMessages.base;
};
export var getLayerPrimaryNav = function (theme) {
    return theme.v1.layers.primaryNav.base;
};
export var getLayerModals = function (theme) {
    return theme.v1.layers.modals.base;
};
